import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { RenjuBoardMenu } from '../../../components'

const mapStateToProps = (state, ownProps) => {
  const { user } = state.authentication
  const { anchorEl, clickedMenu } = state.renjuBoardMenu
  return ({
    user,
    anchorEl,
    clickedMenu,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleClick: (event) => dispatch(actions.renjuBoardMenu.open(event.currentTarget)),
    handleClose: () => dispatch(actions.renjuBoardMenu.close()),
    handleExited: (clickedMenu) => () => {
      ownProps.onExited(clickedMenu)
    },
    handleCloseBoard: () => {
      dispatch(actions.renjuBoardMenu.close())
      ownProps.onCloseBoard()
    },
    handleOpenAnalyzeTab: () => {
      dispatch(actions.renjuBoardMenu.close())
      ownProps.onOpenAnalyzeTab()
    },
    handleAnalyzeMode: () => {
      dispatch(actions.renjuBoardMenu.close())
      dispatch(actions.renjuBoardMenu.clickedMenu('AnalyzeModeOn'))
    },
    handleMarkMode: () => {
      dispatch(actions.renjuBoardMenu.close())
      dispatch(actions.renjuBoardMenu.clickedMenu('MarkModeOn'))
    },
    handleShareDialog: () => {
      dispatch(actions.shareDialog.open())
      dispatch(actions.renjuBoardMenu.close())
    },
    handleTweetDialog: () => {
      dispatch(actions.tweetDialog.open())
      dispatch(actions.renjuBoardMenu.close())
    },
    handleDownloadImageDialog: () => {
      dispatch(actions.downloadImageDialog.open())
      dispatch(actions.renjuBoardMenu.close())
    },
    handleGameInfoDialog: () => {
      dispatch(actions.gameInfoDialog.open())
      dispatch(actions.renjuBoardMenu.close())
    },
    handlePuzzleInfoDialog: () => {
      dispatch(actions.puzzleInfoDialog.open())
      dispatch(actions.renjuBoardMenu.close())
    },
    handleSettingsDialog: () => {
      dispatch(actions.settingsDialog.open(ownProps.settings))
      dispatch(actions.renjuBoardMenu.close())
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RenjuBoardMenu)



// WEBPACK FOOTER //
// ./src/containers/Common/RenjuBoardCard/RenjuBoardMenu.js